"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _state = require("printableWorksheets/state");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SubjectSelector = function SubjectSelector() {
  var subjectCodeToTitleMapper = _defineProperty(_defineProperty({}, _state.SubjectCodes.MATH, 'Math'), _state.SubjectCodes.ELA, 'English');
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    subjectCode = _usePrintableWorkshee.subjectCode,
    setSubjectCode = _usePrintableWorkshee.setSubjectCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grade-selector",
    "data-sentry-component": "SubjectSelector",
    "data-sentry-source-file": "subjectSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "heading"
  }, " Subject"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grades-container subject-selector"
  }, Object.keys(_state.SubjectCodes).map(function (subject) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: subject,
      onClick: function onClick() {
        return setSubjectCode(_state.SubjectCodes[subject]);
      },
      className: "grade ".concat(_state.SubjectCodes[subject] == subjectCode ? 'selected' : '')
    }, subjectCodeToTitleMapper[_state.SubjectCodes[subject]]);
  })));
};
var _default = exports["default"] = SubjectSelector;